import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SORT_DESC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import Refresh from '../../../components/Refresh';
import CompanyList from '../../../components/UrCompanyList';
import {
  restClient, dateIntervalsGenerator, addCounters, formatRubMoney, aggregateSum, aggregatePercentages
} from '../../../common';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import CreateComponent from './Create';
import EditComponent from './Edit';
import Header from './Header';
import {updateAggregationParams2 as updateAggregationParamsAction} from '../../../redux/actions';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],
      filter: {
        company: 'all'
      },
    };

    restClient('GET_CUSTOM', 'getCompaniesList', {
      plan: 'all',
      fired: true,
      showAll: true
    }).then(res => {
      this.setState({
        companies: res
      });
      this.props.updateAggregationParams(this.getCurrentCompany(res, this.state.filter.company));
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.refreshToken !== this.props.refreshToken) {
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: 'all',
        fired: true,
        showAll: true
      }).then(res => {
        this.setState({
          companies: res
        });
      });
    }
  }

  onCompanySelect(id) {
    this.setState({
      filter: {
        ...this.state.filter,
        company: id
      }
    });
    this.props.updateAggregationParams(this.getCurrentCompany(this.state.companies, id));
  }

  getCurrentCompany(companies, filterCompany) {
    if (filterCompany === 'all') {
      return {
        balance: aggregateSum(companies, 'balance'),
        count: aggregateSum(companies, 'count'),
        ctr: aggregatePercentages(companies),
        id: 'all',
        name: 'Все Юридические Компании',
        noanswer: aggregateSum(companies, 'noanswer'),
        payments: aggregateSum(companies, 'payments'),
        rejected: aggregateSum(companies, 'rejected'),
        sum: aggregateSum(companies, 'sum'),
        verified: aggregateSum(companies, 'verified'),
        visited: aggregateSum(companies, 'visited'),
        treaty: aggregateSum(companies, 'treaty')
      };
    }
    const companyIndex = companies.findIndex(i => i.id === filterCompany);
    return companies[companyIndex];
  }

  getCompanyName() {
    const id = this.state.filter.company;
    if (id === 'all') {
      return 'во Всех Юридических Компаниях';
    }
    return `в ${this.state.companies.find(company => company.id === this.state.filter.company).name}`;
  }

  getTitle(companies, filter) {
    if (companies.length && filter && filter.company) return `Финансы. Движение средств ${this.getCompanyName()} `;
    return 'Финансы. Движение средств';
  }

  render() {
    const passedProps = { ...this.props };
    delete (passedProps.refreshToken);
    delete (passedProps.updateAggregationParams);

    const defaultValues = {
      time: (new Date()).toISOString(),
      comment: '',
      sum: null,
      status: 'new'
    };

    if (this.state.filter.company !== 'all') {
      defaultValues.companyId = this.state.filter.company;
    } else {
      defaultValues.companyId = '5b54dd4d791a93dcdc1999d7';
    }

    const create = (handleSubmit) => <CreateComponent onSubmit={handleSubmit} record={defaultValues} companies={this.props.companies} />;
    const edit = (handleSubmit, record) => <EditComponent onSubmit={handleSubmit} record={record} companies={this.props.companies} />;

    const countersFunc = company => ({
      counters: [
        {
          count: company.balance,
          formatFunc: formatRubMoney,
          style: { color: '#353535' }
        },
        {
          count: company.payments,
          formatFunc: formatRubMoney,
          style: { color: '#353535' }
        }
      ]
    });

    return (
      <div className="col-wrapper">
        <div className="col-menu">
          <CompanyList
            data={addCounters(countersFunc)(this.state.companies)}
            selectedId={this.state.filter.company}
            onSelect={this.onCompanySelect.bind(this)}
            aggregate={{
              title: 'Все Юридические Компании',
              counters: [
                { count: aggregateSum(this.state.companies, 'balance'), formatFunc: formatRubMoney },
                { count: aggregateSum(this.state.companies, 'payments'), formatFunc: formatRubMoney },
              ]
            }}
          />
        </div>
        <div className="col-main">
          <EjectedList
            {...passedProps}
            title={this.getTitle(this.props.companies, this.state.filter)}
            sort={{ field: '_createdAt', order: SORT_DESC }}
            perPage={50}
            actions={<Refresh />}
            filter={this.state.filter}
            bulkActions={false}
            style={{ width: '721px' }}
            headercomponent={Header}
            companies={this.props.companies}
            currentCompany={this.getCurrentCompany(this.state.companies, this.state.filter.company)}
          >
            <CustomerDatagrid
              edit={edit}
              create={create}
              companies={this.props.companies}
            />
          </EjectedList>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  companies: state.sc.companies,
  refreshToken: state.sc.refreshToken,
}), {
  updateAggregationParams: updateAggregationParamsAction
})(List);



// WEBPACK FOOTER //
// ./src/pages/admin/payments/List.js